module.exports = __webpack_public_path__ + "img/logoOmega.73d3eb5d.png";